// @ngInject
function salesTotalFilterDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(periodStartDate,
                periodEndDate,
                locations,
                selectedLocation,
                includeApproved,
                includeForProcessing) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'salesTotalFilterDialogController as vm',
            templateUrl: 'services/dialogs/salesTotalFilterDialog/salesTotalFilterDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            periodStartDate: function() {
                return periodStartDate;
            },
            periodEndDate: function() {
                return periodEndDate;
            },
            locations: function() {
                return locations;
            },
            selectedLocation: function() {
                return selectedLocation;
            },
            includeApproved: function() {
                return includeApproved;
            },
            includeForProcessing: function() {
                return includeForProcessing;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function salesTotalFilterDialogController($uibModalInstance,
        periodStartDate,
        periodEndDate,
        locations,
        selectedLocation,
        includeApproved,
        includeForProcessing) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.periodStartDate = periodStartDate;
    vm.periodEndDate = periodEndDate;
    vm.locations = locations;
    vm.selectedLocation = selectedLocation;
    vm.includeApproved = includeApproved;
    vm.includeForProcessing = includeForProcessing;

    function closeModal(confirmation) {
        var response = {
            confirmation: confirmation,
            periodStartDate: vm.periodStartDate,
            periodEndDate: vm.periodEndDate,
            selectedLocation: vm.selectedLocation.id,
            includeApproved: vm.includeApproved,
            includeForProcessing: vm.includeForProcessing
        };
        $uibModalInstance.close(response);
    }
}

angular
    .module('services.dialogs.salesTotalFilterDialog', [])
    .service('salesTotalFilterDialogService', salesTotalFilterDialogService)
    .controller('salesTotalFilterDialogController', salesTotalFilterDialogController);
